import React from 'react'
import compose from 'recompose/compose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _get from 'lodash/get'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { get as getConfig } from '../../../config/index'
import { URL_PLAN_SELECTION_PLANS } from '../../../services/url/constants'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'
import Button, { TYPES } from '../../Button/index'
import { H1, HEADING_TYPES } from '../../Heading/index'
import ConstructionMessage from '../../ConstructionMessage/index'
import { DATA_ACTION_CONTINUE } from '../../Link/constants'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { PLAN_SELECT_PRECURSOR_GA4_EVENT } from '../../../services/event-tracking/index'
import OptimizelyPage from '../../OptimizelyPage/index'

const config = getConfig()
const useFourteenMonthsPlan = !!_get(config, ['features', 'checkoutFourteenMonths'])

function getText (props) {
  const {
    staticText,
    user,
    checkout,
  } = props
  let text = staticText.getIn(['data', 'enjoyTrial'])

  if (checkout.get('reactivation' || user.getIn(['data', 'checkout_complete']))) {
    text = staticText.getIn(['data', 'threeAmazingOffers'])
  }

  if (useFourteenMonthsPlan) {
    text = staticText.getIn(['data', 'blackFridaySpecial'])
  }

  return text
}

function handleSeePlansGaEvent (props) {
  const { setEventDefault, sendOptimizelyFeatureEvent } = props

  // GA4 event
  setEventDefault(PLAN_SELECT_PRECURSOR_GA4_EVENT)

  // optimizely event
  sendOptimizelyFeatureEvent({
    eventName: 'plan_select_precursor',
  })
}

function CartChoosePlanPageV2 (props) {
  const { staticText, checkout, auth } = props
  const underConstruction = _get(config, 'features.zuoraOutage')

  if (underConstruction) return <CartLayoutTemplate colOne={<ConstructionMessage />} />

  if (!getAuthIsLoggedIn(auth) && !checkout.get('account', Map()).size) {
    return null
  }

  return (
    <div className="cart-choose-plan-v2">
      <CartLayoutTemplate
        colOne={
          <React.Fragment>
            <CartProgressIndicator v2 />
            <H1 as={HEADING_TYPES.H3} className="cart-choose-plan-v2__title">
              {staticText.getIn(['data', 'title'])}
            </H1>
            <p className="cart-choose-plan-v2__body">
              {getText(props)}
            </p>
            <Button
              className="cart-choose-plan-v2__button"
              type={TYPES.PRIMARY}
              url={URL_PLAN_SELECTION_PLANS}
              data-action={DATA_ACTION_CONTINUE}
              onClick={() => handleSeePlansGaEvent(props)}
            >
              {staticText.getIn(['data', 'seePlans'])}
            </Button>
          </React.Fragment>
        }
      />
      <OptimizelyPage pageName="web_app__cart_plan_selection" />
    </div>
  )
}

CartChoosePlanPageV2.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  checkout: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'cartChoosePlanPageV2' }),
  connectRedux(
    (state) => ({
      user: state.user,
      auth: state.auth,
      checkout: state.checkout,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
      }
    },
  ),
)(CartChoosePlanPageV2)
